import { render, staticRenderFns } from "./linkPagamento.vue?vue&type=template&id=20f5a704"
import script from "./linkPagamento.ts?vue&type=script&lang=js&external"
export * from "./linkPagamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f5a704')) {
      api.createRecord('20f5a704', component.options)
    } else {
      api.reload('20f5a704', component.options)
    }
    module.hot.accept("./linkPagamento.vue?vue&type=template&id=20f5a704", function () {
      api.rerender('20f5a704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/linkPagamento.vue"
export default component.exports